import React, { useEffect } from "react"
import Fruchtgummi from "../components/Fruchtgummi"
import { updateIframeHeight, updateIframeScrollTo } from "../helper"
import PromoSoonOverHandler from "../components/PromoSoonOverHandler"

const ConfirmContact: React.FC = () => {
	useEffect(() => {
		updateIframeScrollTo(0)
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		})

		updateIframeHeight()
		// eslint-disable-next-line
	}, [])

	return (
		<PromoSoonOverHandler>
			<div className="contentGradient">
				<div className="container text-center py-12">
					<h1 className="h1">Vielen Dank!</h1>
					<h2 className="h2">DEINE DATEN SIND BEI UNS EINGEGANGEN!</h2>

					<p className="pb-6">Dein Gewinn wird innerhalb der nächsten vier Wochen an die von dir angegebene Adresse versandt.</p>
					<a href="https://www.nimm2.de/de/ideen-inspirationen" target="_parent" rel="noopener noreferrer">
						<button className="btn text-[18px] lg:text-[30px]">Entdecke Basteltipps und vieles mehr</button>
					</a>
				</div>

				<Fruchtgummi />
			</div>
		</PromoSoonOverHandler>
	)
}
export default ConfirmContact
